export enum IInputStatus {
  'none',
  'dispensable',
  'disabled',
  'notActive',
  'isOptions',
  'error',
  'apiError',
  'change',
  'valid',
  'success'
}

export enum IStepStatus {
  'none',
  'current',
  'change',
  'success'
}

export interface IInputProgress {
  status: IInputStatus;
  percent: number | null;
}

export interface IInputsProgress {
  [name: string]: IInputProgress
}

export enum IViewStatus {
  'none',
  'current',
  'check'
}

export interface IStepProgress {
  status: IStepStatus;
  viewStatus: IViewStatus;
  percent: number | null;
  inputs: IInputsProgress;
  title: string;
}

export interface IStepsProgress {
  [n: number]: IStepProgress
}